/**
 * Проверяет, истекает ли подписка в течение указанного количества дней
 * @param expDate - дата окончания подписки в формате строки
 * @param daysThreshold - количество дней для проверки (по умолчанию 3)
 * @returns true, если подписка истекает в течение указанного количества дней
 */
export function isSubscriptionExpiringSoon(expDate: string, daysThreshold = 3): boolean {
  const expirationDate = new Date(expDate);
  const currentDate = new Date();
  
  // Сбрасываем время до начала дня для корректного сравнения
  expirationDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  
  // Вычисляем разность в миллисекундах и переводим в дни
  const timeDifference = expirationDate.getTime() - currentDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  
  // Возвращаем true, если подписка истекает в течение указанного количества дней (включая сегодня)
  return daysDifference >= 0 && daysDifference <= daysThreshold;
}
